module.exports = __webpack_public_path__ + "media/npc_dota_hero_windrunner.f84c86bf.webm";